// Périmètre « prestations ET lieux » d'un élément configuré par le pro : section d'instructions de
// réservation, champ personnalisé du tunnel. Une seule règle pour tous : elle ne vit qu'ici.

// Une dimension vide ne contraint pas ; sinon au moins un id réservé doit figurer dans le périmètre.
function isPerimeterDimensionSatisfied(
  scopeIds: readonly number[] | null | undefined,
  bookedIds: ReadonlySet<number>,
): boolean {
  if (!scopeIds || scopeIds.length === 0) return true;
  return scopeIds.some((id): boolean => bookedIds.has(id));
}

/**
 * Règle de diffusion d'un élément à périmètre (SOURCE UNIQUE — instructions de réservation : détail
 * agenda, page de gestion client et emails ; champs personnalisés : tunnel classique, tunnel course et
 * backend). Les deux dimensions se CUMULENT (ET) et une dimension VIDE ne contraint pas :
 *  - prestations : vide = toutes ; sinon au moins une prestation réservée figure dans `prestation_ids` ;
 *  - lieux : vide = tous ; sinon au moins un lieu réservé figure dans `pro_place_ids`.
 * L'APPELANT choisit les ensembles réservés : toute la réservation pour la page de gestion client et
 * les emails (prestations et lieux de tous les créneaux, sans coupler prestation et lieu par créneau),
 * le seul rendez-vous ouvert pour le détail agenda, le lieu choisi pour un tunnel. Une réservation SANS
 * lieu (course VTC, RDV manuel sans lieu) ne satisfait donc jamais un élément restreint à des lieux.
 */
export function isBookingPerimeterApplicable(
  scope: { prestation_ids?: readonly number[] | null; pro_place_ids?: readonly number[] | null },
  booked: { prestation_ids: ReadonlySet<number>; pro_place_ids: ReadonlySet<number> },
): boolean {
  return (
    isPerimeterDimensionSatisfied(scope.prestation_ids, booked.prestation_ids) &&
    isPerimeterDimensionSatisfied(scope.pro_place_ids, booked.pro_place_ids)
  );
}

/** Lieux DISTINCTS (non nuls) d'un ensemble de créneaux — entrée `pro_place_ids` de la règle ci-dessus. */
export function collectBookedProPlaceIds(appointments: ReadonlyArray<{ pro_place_id?: number | null }>): number[] {
  return [
    ...new Set(
      appointments.flatMap((appointment): number[] =>
        appointment.pro_place_id != null ? [appointment.pro_place_id] : [],
      ),
    ),
  ];
}
